import React from 'react';
import {classes, stylesheet} from 'typestyle';
import {observer} from 'mobx-react';
import {important} from 'csx';
import {Channel} from '../../types/Channel';
import {BuildingBlockType, MergedBuildingBlockInstructions, NamedDateRangeWithPreviewDateRange, ReportBuildingBlock} from '../types/Report';
import PreviewTextBlock from './PreviewPaperSheetBlocks/PreviewTextBlock';
import PreviewTableBlock from './PreviewPaperSheetBlocks/PreviewTableBlock';
import PreviewDiagramBlock from './PreviewPaperSheetBlocks/PreviewDiagramBlock';
import PreviewDiagramTableBlock from './PreviewPaperSheetBlocks/PreviewDiagramTableBlock';
import {NumericFormatter} from '../../utility/FormatValueUtils';
import {PreviewPageBreakBlock} from './PreviewPaperSheetBlocks/PreviewPageBreakBlock';
import {GreyBlueBackgroundColor, Shadow1, WhiteColor} from '../../styles/colors';

interface PreviewPaperSheetProps {
    moneyFormatToTargetCurrency: (fractions?: number) => NumericFormatter;
    targetCurrency?: string;
    reportBuildingBlocks: ReportBuildingBlock[];
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
    getFullChannelForChannelName: (channelName: string) => Channel;
    namedDateRanges: NamedDateRangeWithPreviewDateRange[];
}

@observer
export default class PreviewPaperSheet extends React.Component<PreviewPaperSheetProps> {
    private getSelectedNameDateRange(idSelectedNamedDateRange?: string): NamedDateRangeWithPreviewDateRange | undefined {
        return this.props.namedDateRanges.find((namedDateRange) => namedDateRange.id === idSelectedNamedDateRange);
    }

    private renderBuildingBlockBody = (buildingBlock: ReportBuildingBlock) => {
        const {getFullChannelForChannelName, targetCurrency, moneyFormatToTargetCurrency} = this.props;
        switch (buildingBlock.blockType) {
            case BuildingBlockType.TEXT:
                return <PreviewTextBlock buildingBlock={buildingBlock} />;
            case BuildingBlockType.TABLE:
                return (
                    <PreviewTableBlock
                        moneyFormatToTargetCurrency={moneyFormatToTargetCurrency}
                        targetCurrency={targetCurrency}
                        buildingBlock={buildingBlock}
                        getFullChannelForChannelName={getFullChannelForChannelName}
                        getMergedBuildingBlockInstructions={this.props.getMergedBuildingBlockInstructions}
                        selectedNamedDateRange={this.getSelectedNameDateRange(buildingBlock.idDate)}
                    />
                );
            case BuildingBlockType.DIAGRAM:
                return (
                    <PreviewDiagramBlock
                        targetCurrency={targetCurrency}
                        buildingBlock={buildingBlock}
                        selectedNamedDateRange={this.getSelectedNameDateRange(buildingBlock.idDate)}
                        selectedNamedCompareDateRange={this.getSelectedNameDateRange(buildingBlock.idDateCompare)}
                        getFullChannelForChannelName={getFullChannelForChannelName}
                        getMergedBuildingBlockInstructions={this.props.getMergedBuildingBlockInstructions}
                    />
                );
            case BuildingBlockType.DIAGRAM_TABLE:
                return (
                    <PreviewDiagramTableBlock
                        targetCurrency={targetCurrency}
                        buildingBlock={buildingBlock}
                        moneyFormatToTargetCurrency={moneyFormatToTargetCurrency}
                        getFullChannelForChannelName={getFullChannelForChannelName}
                        getMergedBuildingBlockInstructions={this.props.getMergedBuildingBlockInstructions}
                        selectedNamedDateRange={this.getSelectedNameDateRange(buildingBlock.idDate)}
                        selectedNamedCompareDateRange={this.getSelectedNameDateRange(buildingBlock.idDateCompare)}
                    />
                );
            case BuildingBlockType.PAGE_BREAK:
                return <PreviewPageBreakBlock />;
            default:
                throw Error('Unsupported building block type');
        }
    };

    private renderReportBuildingBlock = (buildingBlock: ReportBuildingBlock, index: number) => {
        return (
            <div className={classes(paperCss.blockContainer)} key={buildingBlock.id}>
                <div className={paperCss.blockBody}>{this.renderBuildingBlockBody(buildingBlock)}</div>
            </div>
        );
    };

    public render() {
        return <div className={paperCss.paper}>{this.props.reportBuildingBlocks.map(this.renderReportBuildingBlock)}</div>;
    }
}

// FIXME: Remove duplicated code from PaperSheet.tsx
const paperCss = stylesheet({
    paperHover: {
        backgroundColor: important(GreyBlueBackgroundColor),
    },
    combineHovered: {
        backgroundColor: GreyBlueBackgroundColor,
    },
    paper: {
        transition: '.2s',
        overflow: 'auto',
        padding: '15px 15px 0px 15px',
        backgroundColor: WhiteColor,
        height: '100%',
        width: '100%',
        boxShadow: Shadow1,
    },
    blockContainer: {
        justifyContent: 'center',
        marginBottom: 15,
        cursor: 'move',
        backgroundColor: WhiteColor,
        display: 'flex',
    },
    grabHandle: {
        minWidth: 16,
    },
    blockBody: {
        flexGrow: 1,
        width: 1,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheet.tsx